import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import moment from 'moment'
import Pagination from 'react-js-pagination'
import DateTime from 'react-datetime'
import includes from 'lodash/includes'
import isObject from 'lodash/isObject'
import FormatMoney from '../../Utils/FormatMoney'

class OrderReport extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'Y-MM-DD'
    this.state = {
      tab: 'modem-vending',
      showModal: null,
      filter: {
        page: 1,
        from: moment().subtract(1, 'months').format(this.dateFormat),
        until: moment().format(this.dateFormat)
      }
    }
  }

  componentDidMount = () => {
    this._fetchData()
  }

  _fetchData = (filter = { page: 1 }, event) => {
    if (event) event.preventDefault()
    let params = {
      ...this.state.filter,
      ...filter
    }
    if (this.state.filter.from && this.state.filter.until) {
      params.from = moment(this.state.filter.from).format(this.dateFormat)
      params.until = moment(this.state.filter.until).format(this.dateFormat)
    } else {
      params.from = null
      params.until = null
    }
    params.type = this.state.tab
    params.page = this.state.filter.page
    this.props.getOrderReport(params)
  }

  _filterChange = (data, field) => {
    const unique = ['page', 'from', 'until']
    let value = null
    if (includes(unique, field)) {
      if (field === 'from' || field === 'until') {
        if (isObject(data)) {
          value = data
        }
      } else {
        value = data
      }
    } else {
      value = data.target.value
    }
    let filter = { ...this.state.filter }
    filter[field] = value
    this.setState({ filter })
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    setTimeout(() => {
      this._fetchData({ page })
    }, 80)
  }

  _changeTab = (tab) => {
    let filter = { ...this.state.filter }
    filter.page = 1
    this.setState({ filter, tab })
    setTimeout(() => {
      this._fetchData()
    }, 80)
  }

  _downloadXLS = (type) => {
    let data = {
      from: moment(this.state.filter.from).format(this.dateFormat),
      until: moment(this.state.filter.until).format(this.dateFormat),
      type: type
    }
    setTimeout(() => {
      this.props.getOrderReportSpreadsheet(data)
    }, 500)
  }

  _renderMeta = (data, dataStatModem, tab) => {
    switch (tab) {
      case 'modem':
        return (
          (!data || !dataStatModem)
            ? <div />
            : <section className='section'>
              <div className='card card-info'>
                <div className='card-header d-flex justify-content-between'>
                  <div className='header-block mr-auto'>
                    <p className='title mr-auto'>Financial Report (Modem)</p>
                  </div>
                  <div className='btn-group mr-2' role='group'>
                    <button className='btn btn-primary' onClick={() => this._downloadXLS('modem')}><i className='fa fa-download' /> Download XLS</button>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-block'>
                    <div className='card-title-block'>
                      <h2 className='title'>Order via Travypass</h2>
                    </div>
                    <section className='section'>
                      <table className='table table-striped table-bordered'>
                        <thead>
                          <tr>
                            <th className='text-center align-middle'>Terminal</th>
                            <th className='text-center align-middle'>Total Quantity</th>
                            <th className='text-center align-middle'>Total Revenue</th>
                            <th className='text-center align-middle'>Total Commission</th>
                            <th className='text-center align-middle'>Total Gross Margin</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className='text-center align-middle'>Terminal 2 Bandara Soekarno Hatta</td>
                            <td className='text-center align-middle'>{data.total_qty_2}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(data.total_revenue_2)}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(data.total_commission_2)}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(data.total_gross_margin_2)}</td>
                          </tr>
                          <tr>
                            <td className='text-center align-middle'>Terminal 3 Bandara Soekarno Hatta</td>
                            <td className='text-center align-middle'>{data.total_qty_3}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(data.total_revenue_3)}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(data.total_commission_3)}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(data.total_gross_margin_3)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>
                <hr />
                <div className='card'>
                  <div className='card-block'>
                    <div className='card-title-block'>
                      <h2 className='title'>Order via Passpod</h2>
                    </div>
                    <section className='section'>
                      <table className='table table-striped table-bordered'>
                        <thead>
                          <tr>
                            <th className='text-center align-middle'>Terminal</th>
                            <th className='text-center align-middle'>Received on Airport</th>
                            <th className='text-center align-middle'>Returned on Airport</th>
                            <th className='text-center align-middle'>Commission (receive)</th>
                            <th className='text-center align-middle'>Commission (return)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className='text-center align-middle'>Terminal 2 Bandara Soekarno Hatta</td>
                            <td className='text-center align-middle'>{dataStatModem.qtyReceived2}</td>
                            <td className='text-center align-middle'>{dataStatModem.qtyReturn2}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissiontyReceived2)}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissionReturn2)}</td>
                          </tr>
                          <tr>
                            <td className='text-center align-middle'>Terminal 3 Bandara Soekarno Hatta</td>
                            <td className='text-center align-middle'>{dataStatModem.qtyReceived3}</td>
                            <td className='text-center align-middle'>{dataStatModem.qtyReturn3}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissiontyReceived3)}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissionReturn3)}</td>
                          </tr>
                          <tr>
                            <td className='text-center align-middle'><i>Total</i></td>
                            <td className='text-center align-middle'>{dataStatModem.qtyReceived2 + dataStatModem.qtyReceived3}</td>
                            <td className='text-center align-middle'>{dataStatModem.qtyReturn2 + dataStatModem.qtyReturn3}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissiontyReceived2 + dataStatModem.commissiontyReceived3)}</td>
                            <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissionReturn2 + dataStatModem.commissionReturn3)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>
              </div>
            </section>
        )
      case 'attraction':
        return (
          !data
            ? <div />
            : <section className='section'>
              <div className='card card-info'>
                <div className='card-header d-flex justify-content-between'>
                  <div className='header-block mr-auto'>
                    <p className='title mr-auto'>Financial Report (Attraction)</p>
                  </div>
                  <div className='btn-group mr-2' role='group'>
                    <button className='btn btn-primary' onClick={() => this._downloadXLS('attraction')}><i className='fa fa-download' /> Download XLS</button>
                  </div>
                </div>
                <div className='card-block'>
                  <table className='table table-striped table-bordered'>
                    <thead>
                      <tr>
                        <th className='text-center align-middle'>Total Adults</th>
                        <th className='text-center align-middle'>Total Children</th>
                        <th className='text-center align-middle'>Total Seniors</th>
                        <th className='text-center align-middle'>Total Revenue</th>
                        <th className='text-center align-middle'>Total Commission</th>
                        <th className='text-center align-middle'>Total Gross Margin</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className='text-center'>{data.total_adults}</td>
                        <td className='text-center'>{data.total_children}</td>
                        <td className='text-center'>{data.total_seniors}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_revenue)}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_commission)}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_gross_margin)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
        )
      case 'modem-vending':
        return (
          (!data || !dataStatModem)
            ? <div />
            : <section className='section'>
              <div className='card card-info'>
                <div className='card-header d-flex justify-content-between'>
                  <div className='header-block mr-auto'>
                    <p className='title mr-auto'>Modem Travelinpod</p>
                  </div>
                  <div className='btn-group mr-2' role='group'>
                    <button className='btn btn-primary' onClick={() => this._downloadXLS('modem-vending')}><i className='fa fa-download' /> Download XLS</button>
                  </div>
                </div>
                <div className='card-block'>
                  <div className='card-title-block'>
                    <h2 className='title'>Order via Travelinpod</h2>
                  </div>
                  <table className='table table-striped table-bordered'>
                    <thead>
                      <tr>
                        <th className='text-center align-middle'>Total Quantity</th>
                        <th className='text-center align-middle'>Total Revenue</th>
                        <th className='text-center align-middle'>Total Commission</th>
                        <th className='text-center align-middle'>Total Gross Margin</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className='text-center'>{data.total_qty}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_revenue)}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_commission)}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_gross_margin)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='card'>
                <div className='card-block'>
                  <div className='card-title-block'>
                    <h2 className='title'>Order via Passpod</h2>
                  </div>
                  <section className='section'>
                    <table className='table table-striped table-bordered'>
                      <thead>
                        <tr>
                          <th className='text-center align-middle'>Terminal</th>
                          <th className='text-center align-middle'>Received on Airport</th>
                          <th className='text-center align-middle'>Returned on Airport</th>
                          <th className='text-center align-middle'>Commission (receive)</th>
                          <th className='text-center align-middle'>Commission (return)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className='text-center align-middle'>Terminal 2 Bandara Soekarno Hatta</td>
                          <td className='text-center align-middle'>{dataStatModem.qtyReceived2}</td>
                          <td className='text-center align-middle'>{dataStatModem.qtyReturn2}</td>
                          <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissiontyReceived2)}</td>
                          <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissionReturn2)}</td>
                        </tr>
                        <tr>
                          <td className='text-center align-middle'>Terminal 3 Bandara Soekarno Hatta</td>
                          <td className='text-center align-middle'>{dataStatModem.qtyReceived3}</td>
                          <td className='text-center align-middle'>{dataStatModem.qtyReturn3}</td>
                          <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissiontyReceived3)}</td>
                          <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissionReturn3)}</td>
                        </tr>
                        <tr>
                          <td className='text-center align-middle'><i>Total</i></td>
                          <td className='text-center align-middle'>{dataStatModem.qtyReceived2 + dataStatModem.qtyReceived3}</td>
                          <td className='text-center align-middle'>{dataStatModem.qtyReturn2 + dataStatModem.qtyReturn3}</td>
                          <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissiontyReceived2 + dataStatModem.commissiontyReceived3)}</td>
                          <td className='text-center align-middle'>IDR {FormatMoney(dataStatModem.commissionReturn2 + dataStatModem.commissionReturn3)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>
            </section>
        )
      case 'ecommerce':
        return (
          !data
            ? <div />
            : <section className='section'>
              <div className='card card-info'>
                <div className='card-header d-flex justify-content-between'>
                  <div className='header-block mr-auto'>
                    <p className='title mr-auto'>Travel Smart Card in Travelinpod</p>
                  </div>
                  <div className='btn-group mr-2' role='group'>
                    <button className='btn btn-primary' onClick={() => this._downloadXLS('ecommerce')}><i className='fa fa-download' /> Download XLS</button>
                  </div>
                </div>
                <div className='card-block'>
                  <table className='table table-striped table-bordered'>
                    <thead>
                      <tr>
                        <th className='text-center align-middle'>Total Quantity</th>
                        <th className='text-center align-middle'>Total Revenue</th>
                        <th className='text-center align-middle'>Total Commission</th>
                        <th className='text-center align-middle'>Total Gross Margin</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className='text-center'>{data.total_qty}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_revenue)}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_commission)}</td>
                        <td className='text-center'>IDR {FormatMoney(data.total_gross_margin)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
        )
      default:
        return null
    }
  }

  _renderData = (data, tab) => {
    if (this.props.order.err) {
      return (
        <div className='alert alert-danger'>{this.props.order.err}</div>
      )
    }
    switch (tab) {
      case 'modem':
        return (
          <table className='text-center align-middle table-bordered'>
            <thead>
              <tr>
                <th className='text-center'>Receive Date</th>
                <th className='text-center'>Terminal (receive)</th>
                <th className='text-center'>Terminal (return) </th>
                <th className='text-center'>Rent Duration</th>
                <th className='text-center'>Quantity</th>
                <th className='text-center'>Revenue</th>
                <th className='text-center'>Commission</th>
                <th className='text-center'>Gross Margin</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map((item, i) => (
                  <tr key={i}>
                    <td className='text-center align-middle'>{item.terminal_received_date || '-'}</td>
                    <td className='text-center align-middle'>{item.terminal_received || '-'}</td>
                    <td className='text-center align-middle'>{item.terminal_return || '-'}</td>
                    <td className='text-center align-middle'>{item.rent_duration || '-'}</td>
                    <td className='text-center align-middle'>{item.total_qty || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.revenue) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.commission) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.gross_margin) || '-'}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )
      case 'attraction':
        return (
          <table className='text-center align-middle table-bordered' style={{ width: '150%', backgroundColor: '#ffffff' }}>
            <thead>
              <tr>
                <th className='text-center'>Package Name</th>
                <th className='text-center'>Country</th>
                <th className='text-center'>Confirm Date</th>
                <th className='text-center'>Adults</th>
                <th className='text-center'>Children</th>
                <th className='text-center'>Seniors</th>
                <th className='text-center'>Revenue</th>
                <th className='text-center'>Commission</th>
                <th className='text-center'>Gross Margin</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map((item, i) => (
                  <tr key={i}>
                    <td className='text-center align-middle'>{item.attraction_name || '-'}</td>
                    <td className='text-center align-middle'>{item.country || '-'}({item.currency_code || '-'})</td>
                    <td className='text-center align-middle'>{item.confirm_date || '-'}</td>
                    <td className='text-center align-middle'>{item.total_adults || '-'}</td>
                    <td className='text-center align-middle'>{item.total_children || '-'}</td>
                    <td className='text-center align-middle'>{item.total_seniors || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.revenue) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.commission) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.gross_margin) || '-'}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )
      case 'ecommerce':
        return (
          <table className='table text-center align-middle table-bordered' style={{ backgroundColor: '#ffffff' }}>
            <thead>
              <tr>
                <th className='text-center'>Produk</th>
                <th className='text-center'>SKU M</th>
                <th className='text-center'>SKU V</th>
                <th className='text-center'>Quantity</th>
                <th className='text-center'>Revenue</th>
                <th className='text-center'>Commission</th>
                <th className='text-center'>Gross Margin</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map((item, i) => (
                  <tr key={i}>
                    <td className='text-left'>{item.name || '-'}</td>
                    <td className='text-left'>{item.sku_m || '-'}</td>
                    <td className='text-left'>{item.sku_v || '-'}</td>
                    <td className='text-center align-middle'>{item.total_qty || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.revenue) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.commission) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.gross_margin) || '-'}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )
      case 'modem-vending':
        return (
          <table className='text-center align-middle table-bordered'>
            <thead>
              <tr>
                <th className='text-center'>Quantity</th>
                <th className='text-center'>Revenue</th>
                <th className='text-center'>Commission</th>
                <th className='text-center'>Gross Margin</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map((item, i) => (
                  <tr key={i}>
                    <td className='text-center align-middle'>{item.total_qty || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.revenue) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.commission) || '-'}</td>
                    <td className='text-center align-middle'>IDR {FormatMoney(item.gross_margin) || '-'}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )
      default:
        return null
    }
  }

  render () {
    const { order } = this.props
    const { DATA_REPORT } = order
    return (
      <section className='section'>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Travelinpod Order Report
              {
                (order.fetching || order.processing) &&
                <div className='badge badge-info ml-2'>Loading ...</div>
              }
            </h3>
            <div className='btn-group' role='group'>
              <button className={`btn btn-primary ${this.state.tab === 'modem-vending' && 'active'}`} onClick={() => this._changeTab('modem-vending')}>Modem</button>
              <button className={`btn btn-primary ${this.state.tab === 'ecommerce' && 'active'}`} onClick={() => this._changeTab('ecommerce')}>E Commerce</button>
              {/* <button className={`btn btn-primary ${this.state.tab === 'attraction' && 'active'}`} onClick={() => this._changeTab('attraction')}>Attraction</button> */}
            </div>
          </div>
          <div className='title-block'>
            <form className='form-inline' onSubmit={(event) => this._fetchData(null, event)}>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Date Range:</label>
                <DateTime
                  value={this.state.filter.from}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'from')}
                  dateFormat={this.dateFormat}
                  timeFormat={false}
                />
                <label className='control-label ml-2 mr-2'>To:</label>
                <DateTime
                  value={this.state.filter.until}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'until')}
                  dateFormat={this.dateFormat}
                  timeFormat={false}
                />
              </div>
              <div className='form-group mr-2 mb-2'>
                <button className='btn btn-primary' type='submit'>Change Date Range</button>
              </div>
            </form>
          </div>
        </header>
        {!(order.fetching || order.processing) && order.err &&
          <div className='alert alert-danger'>{order.err}</div>
        }
        { this._renderMeta(DATA_REPORT.metaTravypass, DATA_REPORT.stat_modem_passpod, this.state.tab) }
        <section className='section'>
          <div className='card'>
            {
              this.state.tab === 'modem' &&
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Name</th>
                    <th className='text-center'>Data</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (!DATA_REPORT.data || !DATA_REPORT.data.length)
                      ? <tr>
                        <td className='text-center' colSpan={2}>--No Data--</td>
                      </tr>
                      : DATA_REPORT.data.map((item, i) => (
                        <tr key={i}>
                          <td className='align-middle text-center'><h5>{item.data[0].title}</h5></td>
                          <td className='text-center'>
                            { this._renderData(item.data, this.state.tab) }
                          </td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            }
            {
              this.state.tab === 'attraction' &&
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Data</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (!DATA_REPORT.data || !DATA_REPORT.data.length)
                      ? <tr>
                        <td className='text-center'>--No Data--</td>
                      </tr>
                      : DATA_REPORT.data.map((item, i) => (
                        <tr key={i}>
                          <td className='text-center'>{this._renderData(item.data, this.state.tab)}</td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            }
            {
              this.state.tab === 'ecommerce' &&
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Data</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (!DATA_REPORT.data || !DATA_REPORT.data.length)
                      ? <tr>
                        <td className='text-center'>--No Data--</td>
                      </tr>
                      : DATA_REPORT.data.map((item, i) => (
                        <tr key={i}>
                          <td className='text-center'>{this._renderData(item.data, this.state.tab)}</td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            }
            {
              this.state.tab === 'modem-vending' &&
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Modem</th>
                    <th className='text-center'>Data</th>
                  </tr>
                </thead>
                <tbody>
                {
                  (!DATA_REPORT.data || !DATA_REPORT.data.length)
                    ? <tr>
                      <td className='text-center' colSpan={2}>--No Data--</td>
                    </tr>
                    : DATA_REPORT.data.map((item, i) => (
                      <tr key={i}>
                        <td className='align-middle text-center'><h5>{item.data[0].title}</h5></td>
                        <td className='text-center'>
                          { this._renderData(item.data, this.state.tab) }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            }
          </div>
        </section>
        <section className='text-center'>
          {
            (DATA_REPORT && DATA_REPORT.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={DATA_REPORT.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={DATA_REPORT.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  getOrderReport: (filter) => dispatch(OrderActions.getOrderReportRequest(filter)),
  getOrderReportSpreadsheet: (data) => dispatch(OrderActions.getOrderReportSpreadsheetRequest(data))
})

export default connect(stateToProps, dispatchToProps)(OrderReport)



// WEBPACK FOOTER //
// ./src/Pages/Travypass/OrderReport.js